export let appFiles = "W5b5p";
export default {appFiles};